import React, { useEffect, useState } from "react";
import { MAlE, USER, USER1 } from "../../components/image";
import CountryList from "country-list-with-dial-code-and-flag";
import { useParams } from "react-router-dom";

const ViewAdmins = () => {
  const [admin, setAdmin] = useState({});
  const params = useParams();

  const getViewAdmins = async () => {
    try {
      const response = null;
      if (response) {
        setAdmin(response);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getViewAdmins();
  }, []);

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="people-outline"></ion-icon>
          <span className="text">View Admin</span>
        </div>
      </div>

      <div className="mt-4">
        <div className="userInfo">
          <label>Name</label>
          <div>{admin.name}</div>
        </div>
        {/* <div className="userInfo mt-4">
          <label>Profile</label>
          <div>
            <img src={USER1} className="userProfile" />
          </div>
        </div> */}

        <div className="userInfo mt-4">
          <label>Email</label>
          <div>{admin.email}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Role</label>
          <div>{admin.role}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Status</label>
          <div>{admin.status}</div>
        </div>

        {/* <div className="userInfo mt-4">
          <label>Status</label>
          <div className="round-bg">{admin.status}</div>
        </div> */}
      </div>
    </div>
  );
};

export default ViewAdmins;
